import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import English translations
import commonEn from './locales/en/common.json'
import landingEn from './locales/en/landing.json'
import solutionsEn from './locales/en/solutions.json'
import pricingEn from './locales/en/pricing.json'
import appEn from './locales/en/app.json'
import legalEn from './locales/en/legal.json'
import companyEn from './locales/en/company.json'
import billingEn from './locales/en/billing.json'
import partnerEn from './locales/en/partner.json'
import useCasesEn from './locales/en/useCases.json'
import consultantsEn from './locales/en/consultants.json'
import partnersEn from './locales/en/partners.json'
import hrEn from './locales/en/hr.json'
import settingsEn from './locales/en/settings.json'
import enterpriseEn from './locales/en/enterprise.json'
import integrationsEn from './locales/en/integrations.json'
import roiEn from './locales/en/roi.json'
import compareEn from './locales/en/compare.json'
import blogEn from './locales/en/blog.json'
import comparisonEn from './locales/en/comparison.json'

// Import French translations
import commonFr from './locales/fr/common.json'
import landingFr from './locales/fr/landing.json'
import solutionsFr from './locales/fr/solutions.json'
import pricingFr from './locales/fr/pricing.json'
import appFr from './locales/fr/app.json'
import legalFr from './locales/fr/legal.json'
import companyFr from './locales/fr/company.json'
import billingFr from './locales/fr/billing.json'
import partnerFr from './locales/fr/partner.json'
import useCasesFr from './locales/fr/useCases.json'
import consultantsFr from './locales/fr/consultants.json'
import partnersFr from './locales/fr/partners.json'
import hrFr from './locales/fr/hr.json'
import settingsFr from './locales/fr/settings.json'
import enterpriseFr from './locales/fr/enterprise.json'
import integrationsFr from './locales/fr/integrations.json'
import roiFr from './locales/fr/roi.json'
import compareFr from './locales/fr/compare.json'
import blogFr from './locales/fr/blog.json'
import comparisonFr from './locales/fr/comparison.json'

const resources = {
  en: {
    common: commonEn,
    landing: landingEn,
    solutions: solutionsEn,
    pricing: pricingEn,
    app: appEn,
    legal: legalEn,
    company: companyEn,
    billing: billingEn,
    partner: partnerEn,
    useCases: useCasesEn,
    consultants: consultantsEn,
    partners: partnersEn,
    hr: hrEn,
    settings: settingsEn,
    enterprise: enterpriseEn,
    integrations: integrationsEn,
    roi: roiEn,
    compare: compareEn,
    blog: blogEn,
    comparison: comparisonEn,
  },
  fr: {
    common: commonFr,
    landing: landingFr,
    solutions: solutionsFr,
    pricing: pricingFr,
    app: appFr,
    legal: legalFr,
    company: companyFr,
    billing: billingFr,
    partner: partnerFr,
    useCases: useCasesFr,
    consultants: consultantsFr,
    partners: partnersFr,
    hr: hrFr,
    settings: settingsFr,
    enterprise: enterpriseFr,
    integrations: integrationsFr,
    roi: roiFr,
    compare: compareFr,
    blog: blogFr,
    comparison: comparisonFr,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'landing', 'solutions', 'pricing', 'app', 'legal', 'company', 'billing', 'partner', 'partners', 'useCases', 'consultants', 'hr', 'settings', 'enterprise', 'integrations', 'roi', 'compare', 'blog', 'comparison'],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false,
    },
  })

export default i18n
